import styled from 'styled-components';
import { layout, media } from 'src/components/base';

export const FiltersWrapper = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: ${layout.measurements.spacing050};

  ${media.mediumDown`
    margin: 0;
  `}
`;

export const Filter = styled.div`
  width: fit-content;
`;

export const ModalInner = styled.div`
  margin: 0 -${layout.measurements.spacing025} ${layout.measurements
      .spacing100} -${layout.measurements.spacing025};
  padding-top: ${layout.measurements.spacing100};
  display: grid;
  gap: ${layout.measurements.spacing150};
`;

export const IconImageText = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  column-gap: ${layout.measurements.spacing050};
`;
